import type { DlsgPolicy, DlsgPolicyConfig } from '@repo/api-gw-sdk';
import {
  HighFrequencyBackupScheduleFrequency,
  HighFrequencyIntervalConfigIntervalMinutesEnum,
  ResourceType,
  ScheduleMode,
} from '@repo/api-gw-sdk';

export const defaultDlsgPolicyConfig: DlsgPolicyConfig = {
  pathPrefixes: [''],
  isTruncateData: false,
  migrationDelayHours: 5 * 24,
};

export const DEFAULT_DLSG_RETENTION_DAYS = 5;
export const defaultDlsgPolicy: DlsgPolicy = {
  id: '',
  name: '',
  resourceInclusion: [],
  scheduleMode: ScheduleMode.SCHEDULE_MODE_BASIC,
  policyPlan: {
    resourceTypes: [ResourceType.AwsS3],
    backupSchedule: {
      vaultId: '',
      backupRetentionDays: DEFAULT_DLSG_RETENTION_DAYS,
      scheduleConfig: {
        frequency:
          HighFrequencyBackupScheduleFrequency.HIGH_FREQUENCY_BACKUP_SCHEDULE_DAILY,
        dailyConfig: {
          timeOfDay: {
            hour: 0,
            minute: 0,
          },
        },
      },
    },
    dlsgConfig: [defaultDlsgPolicyConfig],
  },
};

export const defaultHourlyDlsgPolicy: DlsgPolicy = {
  ...defaultDlsgPolicy,
  policyPlan: {
    ...defaultDlsgPolicy.policyPlan,
    backupSchedule: {
      ...defaultDlsgPolicy.policyPlan.backupSchedule,
      scheduleConfig: {
        frequency:
          HighFrequencyBackupScheduleFrequency.HIGH_FREQUENCY_BACKUP_SCHEDULE_INTERVAL,
        intervalConfig: {
          intervalMinutes:
            HighFrequencyIntervalConfigIntervalMinutesEnum.NUMBER_60,
        },
      },
    },
  },
};
